import React from "react";
import { Skeleton } from 'primereact/skeleton';
import "./SkeletonComponent.css";

const SkeletonComponent = () => {
    return (
        <div className="skeletonContainer">
            <Skeleton animation="wave" height="48px" className="mb-2" ></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2"></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2" ></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2"></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2" ></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2"></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2"></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2"></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2"></Skeleton>
            <Skeleton animation="wave" height="48px" className="mb-2"></Skeleton>
        </div>
    )
}

export default SkeletonComponent;
